
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {get,post} from '../api'
export default {
components: {
TransferDom,
Popup,
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
XButton,
Group,
XInput,
XTextarea,
XHeader,
Divider,
Toast,
Cell
},
mounted() {
let tag = this.$route.query.tag;
this.Tag=tag;
if(this.GLOBAL.currentUser==undefined&&tag!='S'){
this.$router.push({ path: '/' });
}
if(tag=='A'){
this.isAdd=true;
this.productInfos.forEach(element => {
element.value="";
});

let index = this.$route.query.index;
let parameter={AOwner:this.GLOBAL.currentUser.BusinessGuid,AType:'NONE'};
if(index==0){
parameter.AType='CP';
}
else if(index==1){
parameter.AType='MP';
}
this.PType=parameter.AType;
post('/productattribute/fields', parameter).then(response => {

this.productInfos.splice(0, this.productInfos.length);
if(response.code==1){
this.productInfos=response.data;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
this.productInfos.splice(0, this.productInfos.length);
console.log(error);
});
}
else{
let id = this.$route.query.id;
this.isAdd=false;
this.currentProduct =this.GLOBAL.currentObjs[id];
this.productInfos=JSON.parse(this.currentProduct.PInfo);
}
},
methods:{
save(){
if(this.isAdd==true){
let parameter={POwner:this.GLOBAL.currentUser.BusinessGuid,PType:this.PType,PInfo:JSON.stringify(this.productInfos)};
post('/productinfo/add', parameter).then(response => {
if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
else{
this.currentProduct.PInfo=JSON.stringify(this.productInfos);
post('/productinfo/update', this.currentProduct).then(response => {
if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
},
cancel(){

},
addAttributes(tag){
if(tag==0){
this.newAttrubute={
Guid:'',
AName:'',
AOwner:'',
DelTag:0,
AType:''
};
this.showNAttribute=true;
}
else if(tag==1){
this.newAttrubute.AOwner=this.GLOBAL.currentUser.BusinessGuid;
this.newAttrubute.AType=this.PType;
post('/productattribute/add', this.newAttrubute).then(response => {
if(response.code==1){
this.productInfos.push({label:this.newAttrubute.AName,value:''});
this.SuccessInfo='属性新增成功!',
this.showSuccess=true;
this.showNAttribute=false;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
},
gotoBusiness(){

}
},
data () {
return {
productInfos:[],
currentProduct:{},
isAdd:false,
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'产品发布成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
PType:'',
showNAttribute:false,
newAttrubute:{
Guid:'',
AName:'',
AOwner:'',
DelTag:0,
AType:''
},
Tag:'',
showBusiness:false,
businessDetail:{
BusinessName:'',
BusinessAddress:'',
Contactor:'',
TelNo:'',
Remark:'',
Tag:0
}
}
},
watch: {

showBusiness: function (newVal, oldVal) {
if(newVal==true&&this.businessDetail.Tag==0){
post('/Business/query', {BusinessGuid:this.productInfos.POwner}).then(response => {
if(response.code==1){
this.businessDetail=response.data[0];
this.businessDetail.Tag=1;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/BusinessModules/ProductDetail.vue